export interface WebSocketMessage {
  Type: string;
  Data?: any;
}

export interface AuthenticationRequest {
  ClientId: string;
  ClientSecret: string;
}

export interface PlaylistCommand {
  PlaylistId: string;
  Action: string;
}

export enum ConnectionStatus {
  Disconnected = 'disconnected',
  Connecting = 'connecting',
  Authenticating = 'authenticating',
  Connected = 'connected',
}

export enum LogType {
  Info = 'info',
  Sent = 'sent',
  Received = 'received',
  Error = 'error',
  Success = 'success',
  Warning = 'warning',
}

export interface LogEntry {
  timestamp: Date;
  type: LogType;
  message: string;
}

export interface ClientStats {
  connectionTime: Date | null;
  messagesSent: number;
  messagesReceived: number;
  lastPing: Date | null;
}
